export default {"src":"/_next/static/image/public/assets/icons/shuffle.2e07a4d897a349b918412b49f488252b.svg","height":20,"width":20};